import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface TraderAndDonor {
  id: number | null
  code: string
  name: string
  shortName: string
  rate: string
  phoneType: SystemCode
  phone: string
  zipCode: string
  address: string
  memo: string
  revision: number | null
}

export const defaultTraderAndDonor = (): TraderAndDonor => ({
  id: null,
  code: '',
  name: '',
  shortName: '',
  rate: '',
  phoneType: defaultSystemCode(),
  phone: '',
  zipCode: '',
  address: '',
  memo: '',
  revision: null
})

export function TraderAndDonorFromJSON(json: any): TraderAndDonor {
  return TraderAndDonorFromJSONTyped(json.trader_and_donor)
}

export function TraderAndDonorFromJSONTyped(json: any): TraderAndDonor {
  return {
    id: exists(json, 'id') ? json.id : 0,
    code: exists(json, 'code') ? json.code : '',
    name: exists(json, 'name') ? json.name : '',
    shortName: exists(json, 'short_name') ? json.short_name : '',
    rate: exists(json, 'rate') ? json.rate : 1,
    phoneType: exists(json, 'phone_type')
      ? SystemCodeFromJSON(json.phone_type)
      : defaultSystemCode(),
    phone: exists(json, 'phone') ? json.phone : '',
    zipCode: exists(json, 'zip_code') ? json.zip_code : '',
    address: exists(json, 'address') ? json.address : '',
    memo: exists(json, 'memo') ? json.memo : '',
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
